module.exports = __webpack_public_path__ + "img/sergeant-reason-icon7.93cefc24.png";